<template>
    <div class="container">
        <div class="row">
            <div class="col-2 col-md-1">
                <div class="confirmed-payment d-flex justify-content-center align-items-center float-lg-right">
                    <i class="icon-check"></i>
                </div>
            </div>
            <div class="col-10 col-md-11">
                <h5 class="font-weight-bold mb-0" v-if="bookingState.selectedService && bookingState.selectedService.is_paid == 2" v-html="TEXTS.render(`BOOKING_COMPLETED_THANK_YOU_HEADER`, `paid`)"></h5>
                <h5 class="font-weight-bold mb-0" v-else v-html="TEXTS.render(`BOOKING_COMPLETED_THANK_YOU_HEADER`, `free`)"></h5>
                <p class="d-none d-md-block" v-html="TEXTS.render(`BOOKING_COMPLETED_THANK_YOU_SUBHEADER`, null, {yourEmail})"></p>
                <label v-if="thankYouNote" v-html="thankYouNote"></label>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-block d-md-none mt-2">
                <p class="d-block d-md-none ml-3" v-html="TEXTS.render(`BOOKING_COMPLETED_THANK_YOU_SUBHEADER`, null, {yourEmail})"></p>
            </div>
        </div>
    </div>
</template>

<script>
    import Texts from '../../../../common/utils/Texts'

    export default {
        computed: {
            TEXTS: ()=> Texts,
            bookingState : function(){
                return this.$store.getters.GET_BOOKING_STATE;
            },
            selectedServiceWording(){
                var bookingState = this.bookingState
                if(bookingState && bookingState.selectedService){
                    return bookingState.selectedService.wording
                }
            },
            thankYouNote(){
                if(this.selectedServiceWording && this.selectedServiceWording.thank_you_note){
                    return this.selectedServiceWording.thank_you_note
                }
                else {
                    return ""
                }
            },
            yourEmail: function () {
                return this.bookingState ? (this.bookingState.personalInfo ? (this.bookingState.personalInfo.email || '') : '') : '';
            }
        }
    }
</script>